import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ChangeHistoryOrangeIcon, CircleOutlineBlueIcon, DoDisturbGrayIcon, } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/** 「締切間近」と表示するための境界値 */
const THRESHOLD_DAYS = 3;
/**
 * コンサルタント：案件質問のステータス表示用のコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalQuestionStatusIconTextGroup = (props) => {
    const { className = '', daysLeft, isExpired = false } = props;
    const Content = (() => {
        if (daysLeft < 0 || isExpired) {
            // 期限を過ぎている
            return (_jsxs(_Fragment, { children: [_jsx(DoDisturbGrayIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'textGray', size: 'sm' }, { children: "\u7DE0\u5207\u6E08" }))] }));
        }
        return daysLeft <= THRESHOLD_DAYS ? (_jsxs(_Fragment, { children: [_jsx(ChangeHistoryOrangeIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: "\u7DE0\u5207\u9593\u8FD1" }))] })) : (_jsxs(_Fragment, { children: [_jsx(CircleOutlineBlueIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: "\u53D7\u4ED8\u4E2D" }))] }));
    })();
    return _jsx(IconTextGroup, Object.assign({ className: className }, { children: Content }));
};
